import Api from './Api'

const endpoint = 'sponsors';

export default class SponsorService extends Api {

    async all (filter) {
        const response = await this.client.get(`${endpoint}/all`, {
            params: {
                field: 'name',
                value: filter
            }
        });
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name
                }
            })
        }
        throw new Error('No data')
    }
}
